import { gql } from '@apollo/client';

export const LIST_EMOTIONS_RANK = gql`
  query ListEmotionsRank {
    listEmotionsRank {
      docs {
        _id
        name
        episodes
        likes
        started
        finished
        percentage
      }
    }
  }
`;
